<template>
  <header id="site-header">
    <nav id="navbar" :class="{ 'shrunken-navbar': shrinkNavbar }" @scroll="handleScroll" v-click-outside="() => clickOffNavbar()">
      <div class="nav-section-wrapper">
        <!-- Logo -->
        <section :class="{ 'simple-header': displayMode === 'condensed' }">
          <router-link v-if="!isHelpHq" :to="toHome" id="logo" tabindex="1" @click="handleMenuClose">
            <img :src="headerData.logo.replace(/^~/, '')" alt="Home - Defence Health - logo" />
          </router-link>
          <a v-else :href="`https://${currentHost}/portal`" id="logo" tabindex="1" @click="handleMenuClose">
            <img :src="headerData.logo.replace(/^~/, '')" alt="Home - Defence Health - logo" />
          </a>
        </section>

        <!-- Main menu -->
        <Transition name="slide">
          <ol id="main-menu" role="menu" v-if="displayMode !== 'condensed' && showMenu" class="navbar-toplevel-menu" :class="{ 'vertical-menu': displayMenuTabletMobile }">
            <li v-for="(lvl0, lvl0Index) in headerData.menuItems" :key="lvl0Index" role="menuitem" class="menu-item-container">
              <IconButton
                :text="lvl0.text"
                iconHref="/assets/public/images/icons.svg#arrow"
                class="top-level-menu-item"
                :class="currentOpenedMenu === lvl0.text ? 'top-level-menu-selected' : ''"
                :onClick="() => toggleMenuDropDown(lvl0.text)"
                :enterDown="() => toggleMenuDropDown(lvl0.text)"
                aria-label="main-menu-button"
                :aria-controls="`nav-menu-lvl1-${lvl0Index}`"
                :tabindex="lvl0Index + 2"
              ></IconButton>
              <!-- Dropdown menu -->
              <ol
                :id="`nav-menu-lvl1-${lvl0Index}`"
                class="navbar-dropdown-menu"
                :class="[
                  currentOpenedMenu === lvl0.text ? `navbar-dropdown-animation` : '',
                  currentOpenedMenu === lvl0.text && currentDevice !== DeviceTypes.DESKTOP ? `navbar-dropdown-menu-display` : '',
                ]"
                role="dropdown-menu"
              >
                <div class="dropdown-menu-content" :class="shrinkNavbar ? `dropdown-menu-content-shrunken` : ''">
                  <template v-if="currentDevice !== DeviceTypes.DESKTOP">
                    <li role="dropdown-menuitem" v-for="(lvl1, lvl1Index) in lvl0.children" :key="lvl1Index" v-show="currentOpenedMenu === lvl0.text" class="dropdown-menu-item">
                      <!-- Dropdown items w/ sub-items -->
                      <div v-if="lvl1.children.length !== 0" class="navbar-lvl1-item">
                        <router-link
                          v-if="!isHelpHq && checkUrlForMember(lvl1)"
                          :to="lvl1.url.replace(/^~\/portal/i, '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                        >
                          {{ lvl1.text }}
                        </router-link>
                        <a
                          v-else
                          :href="lvl1.url === '' ? '/portal' : `https://${currentHost}/` + lvl1.url.replace('~/', '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                        >
                          {{ lvl1.text }}
                        </a>
                        <!-- Sub-items -->
                        <ol role="dropdown-submenu">
                          <li v-for="(lvl2, lvl2Index) in lvl1.children" :key="lvl2Index" role="dropdown-sub-menuitem" class="navbar-lvl2-item">
                            <router-link
                              v-if="!isHelpHq && checkUrlForMember(lvl1)"
                              :to="lvl2.url.replace(/^~\/portal/i, '').tokenSwap()"
                              @click="handleMenuClose"
                              :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                            >
                              {{ lvl2.text }}
                            </router-link>
                            <a
                              v-else
                              :href="lvl2.url === '' ? '/portal' : `https://${currentHost}/` + lvl2.url.replace('~/', '').tokenSwap()"
                              @click="handleMenuClose"
                              :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                            >
                              {{ lvl2.text }}
                            </a>
                          </li>
                        </ol>
                      </div>
                      <!-- Pure dropdown items -->
                      <div v-else class="navbar-lvl1-item">
                        <router-link
                          v-if="!isHelpHq && checkUrlForMember(lvl1)"
                          :to="lvl1.url.replace(/^~\/portal/i, '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                        >
                          {{ lvl1.text }}
                        </router-link>
                        <a
                          v-else
                          :href="lvl1.url === '' ? '/portal' : `https://${currentHost}/` + lvl1.url.replace('~/', '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl0Index + STARTING_MENU_TAB_INDEX"
                        >
                          {{ lvl1.text }}
                        </a>
                      </div>
                    </li>
                  </template>
                  <template v-else>
                    <li
                      v-for="(lvl1, lvl1Index) in formatDesktopDropdownMenu(lvl0.children)"
                      :key="lvl1Index"
                      v-show="currentOpenedMenu === lvl0.text"
                      class="dropdown-menu-item"
                      role="dropdown-menuitem"
                    >
                      <div :class="lvl1.style === 'item' ? 'navbar-lvl1-item' : 'navbar-lvl2-item'">
                        <router-link
                          v-if="!isHelpHq && checkUrlForMember(lvl1)"
                          :to="lvl1.url.replace(/^~\/portal/i, '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl1.url !== '#' ? lvl0Index + STARTING_MENU_TAB_INDEX : -1"
                        >
                          {{ lvl1.text }}
                        </router-link>
                        <a
                          v-else
                          :href="lvl1.url === '' ? '/portal' : `https://${currentHost}/` + lvl1.url.replace('~/', '').tokenSwap()"
                          @click="handleMenuClose"
                          :tabindex="lvl1.url !== '#' ? lvl0Index + STARTING_MENU_TAB_INDEX : -1"
                        >
                          {{ lvl1.text }}
                        </a>
                      </div>
                    </li>
                  </template>
                </div>
              </ol>
            </li>
          </ol>
        </Transition>
      </div>

      <div class="nav-section-wrapper">
        <!-- Search Icon -->
        <IconButton
          id="search-bar-btn"
          v-if="displayMode !== 'condensed'"
          iconHref="/assets/public/images/icons.svg#dhds-magnifier"
          class="aux-icons search-small-screen"
          :class="searchBarOpened ? `active-icon-btn` : ''"
          :onClick="handleSearchIconClick"
          aria-label="search-button"
          aria-controls="search-bar-input"
          tabindex="6"
          :enterDown="handleSearchIconClick"
        ></IconButton>

        <!-- Search bar -->
        <Transition name="fade">
          <div id="search-bar-input" v-show="searchBarOpened" class="search-bar-container" :style="[!searchBarOpened ? { display: 'none' } : '']">
            <form id="site-search-bar" role="search" @submit.prevent="handleSearchSubmit">
              <div class="site-search-left">
                <input
                  ref="searchBar"
                  id="search-bar"
                  type="text"
                  placeholder="Search"
                  v-model="searchTerm"
                  @focus="suggestionVisible(true)"
                  @keydown.enter.prevent="handleSearchSubmit"
                  @keydown.esc.stop.prevent="handleSearchClose"
                  autocomplete="off"
                  tabindex="7"
                />
              </div>

              <button type="submit" class="site-search-submit non-button-style" tabindex="7" aria-label="Submit search">
                <img src="/assets/public/images/arrow.svg" alt="" aria-hidden="true" />
              </button>

             <!-- Search Suggestions -->
             <ol v-if="showSuggestions && suggestions.length > 0" class="search-suggestions">
              <li
                v-for="suggestion in suggestions"
                :key="`search-suggestion-${suggestion}`"
                @click="handleSearchSuggestionClick(suggestion)"
                @keydown.enter="handleSearchSuggestionClick(suggestion)"
                tabindex="7"
              >
                {{ suggestion }}
              </li>
             </ol>
            </form>
          </div>
        </Transition>

        <!-- Phone details -->
        <Transition name="fade">
          <div class="phone-details" v-show="hidePhoneDetails" :style="[searchBarOpened && currentDevice === DeviceTypes.DESKTOP ? { display: 'none' } : '']">
            <a :aria-label="`Call Defence Health ${headerData.telDisplay}`" :href="'tel:' + headerData.telNumber" tabindex="7">
              <svg class="aux-icons">
                <use xlink:href="/assets/public/images/icons.svg#phone" />
              </svg>
              <p>{{ headerData.telDisplay }}</p>
            </a>
          </div>
        </Transition>

        <!-- Member Details Navbar -->
        <div v-if="displayMode !== 'condensed'" class="member-details-container">
          <div
            class="member-details"
            @click="toggleMemberDetails(`${memberDetailsProp.firstName} ${memberDetailsProp.lastName}`)"
            aria-label="member-details-button"
            aria-controls="member-details-dropdown"
            @keydown.enter="toggleMemberDetails(`${memberDetailsProp.firstName} ${memberDetailsProp.lastName}`)"
            tabindex="8"
          >
            <svg class="aux-icons" :class="currentOpenedMenu === `${memberDetailsProp.firstName} ${memberDetailsProp.lastName}` ? `active-icon` : ''">
              <use xlink:href="/assets/public/images/icons.svg#login" />
            </svg>
            <IconButton
              v-if="currentDevice === DeviceTypes.DESKTOP"
              :text="memberDetailsDisplayName"
              iconHref="/assets/public/images/icons.svg#arrow"
              class="top-level-menu-item"
              :class="currentOpenedMenu === `${memberDetailsProp.firstName} ${memberDetailsProp.lastName}` ? 'top-level-menu-selected' : ''"
            ></IconButton>
          </div>
          <!-- Member Details Dropdown -->
          <Transition :name="currentDevice !== DeviceTypes.DESKTOP ? 'slide' : 'fade'">
            <ol id="member-details-dropdown" v-if="currentOpenedMenu === `${memberDetailsProp.firstName} ${memberDetailsProp.lastName}`" class="member-details-dropdown">
              <Spinner v-if="this.apiStatus.membershipInfo.loading" />
              <!-- Member details dropdown - Fail State -->
              <li v-if="this.apiStatus.membershipInfo.fail && membershipInfo == null">
                <p><strong>Product name</strong></p>
                <p>I’m covered until DD Month YYYY</p>
              </li>

              <!-- Member details dropdown - Success State  -->
              <li v-else class="member-details-content-container">
                <!-- Member details overview -->
                <div>
                  <p class="title">
                    {{ membershipInfo != null ? membershipInfo.productName : 'No product found ' }}
                  </p>
                  <p v-if="datePaidToFormatted === null">Your first premium has not been paid</p>
                  <p v-else>This membership is covered until {{ datePaidToFormatted }}</p>
                  <p v-if="isBeforeDate">Premiums are in arrears</p>
                  <p>
                    {{ memberDetailsProp.firstName }} {{ memberDetailsProp.lastName }}
                    <br />
                    #{{ policyNumber }}
                  </p>
                </div>
                <!-- Member details dropdown links -->
                <div>
                  <li v-for="(linkItem, index) in memberDetailsDropdownLinks" :key="index" class="member-details-link">
                    <router-link v-if="!isHelpHq" :to="linkItem.to" @click="toggleMenuDropDown('')">
                      {{ linkItem.text }}
                    </router-link>
                    <a v-else :href="`https://${currentHost}/portal/${policyNumber}/${linkItem.to.name}`" @click="toggleMenuDropDown('')">
                      {{ linkItem.text }}
                    </a>
                  </li>
                  <li class="member-details-link">
                    <a class="" :href="memberDetailsProp.memberItems.changePassword" target="_blank" @click="toggleMenuDropDown('')">Change password</a>
                  </li>
                  <li v-if="memberDetailsProp.memberItems.showAccountSecurityMenu" class="member-details-link">
                    <a class="" :href="'/MemberPortal/GetRequestAccountManagement'" target="_blank" @click="toggleMenuDropDown('')">Account Security</a>
                  </li>
                  <li v-if="moreThanOneMembership" class="member-details-link">
                    <router-link v-if="!isHelpHq" :to="toPolicySelection" class="" @click="toggleMenuDropDown('')">View another policy</router-link>
                    <a v-else :href="`https://${currentHost}/portal`" class="" @click="toggleMenuDropDown('')">View another policy</a>
                  </li>
                  <li id="menu-item-member-logout" role="menuitem" class="member-details-link">
                    <a id="" :href="logoutUrl" @click="logoutMember">Log out</a>
                  </li>
                </div>
              </li>
            </ol>
          </Transition>
        </div>

        <!-- Hamburger Menu -->
        <IconButton
          id="hamburger-menu-btn"
          v-if="displayMode !== 'condensed'"
          iconHref="/assets/public/images/icons.svg#hamburger-menu"
          class="menu-small-screen"
          :class="displayMenuTabletMobile ? `active-icon` : ''"
          :onClick="toggleHamburgerMenu"
          :enterDown="toggleHamburgerMenu"
          aria-label="hamburger-button"
          aria-controls="main-menu"
          tabindex="1"
        ></IconButton>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { format, isBefore } from 'date-fns';
import { Services } from '@/services/Services';
import Spinner from '@general/js/components/Spinner.vue';
import { IconButton } from '@general/js/components/index';
import HomePageServices from '@general/js/services/HomePage';
import { VUEX_GENERAL } from '@/constants/VuexConstants';
import { HOME, MY_DETAILS_MEMBER_SELECTION, MY_DETAILS_POLICY_SELECTION, GENERATE_MEMBER_CARD_REQUEST, PAYMENT_SELECTION, SEARCH_RESULT_FOUND } from '@/router/routeNames';
import DeviceTypes from '@/enums/DeviceTypes';
import { logoutMember, getDisplayMode, getCurrentDeviceLayout } from '@/utils';
import SearchMixin from '@/_memberPortalSearchMixin';

const STARTING_MENU_TAB_INDEX = 2;

export default {
  name: 'MemberPortalNavigation',

  mixins: [SearchMixin],

  components: {
    IconButton,
    Spinner,
  },

  props: {
    headerData: {
      required: true,
      type: Object,
    },

    memberDetailsProp: {
      required: false,
      type: Object,
    },

    isHelpHq: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      apiStatus: {
        membershipInfo: {
          fail: false,
          loading: false,
        },
      },
      currentDevice: DeviceTypes.DESKTOP,
      currentOpenedMenu: '',
      currentHost: window.location.host,
      displayMenuTabletMobile: false,
      DeviceTypes,
      shrinkNavbar: false,
      searchBarOpened: false,
      STARTING_MENU_TAB_INDEX,
    };
  },

  beforeMount() {
    this.resizeHandler();
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.resizeHandler);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.resizeHandler);
  },

  watch: {
    '$route.params': {
      handler(value) {
        if (value?.policyNumber) {
          // only fetch data when policy is selected
          this.getMembershipData();
        }
      },
      deep: true,
      immediate: true, // this is required so that data is fetched on initial load
    },
  },

  computed: {
    ...mapGetters({
      policyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      memberDetailsVuex: VUEX_GENERAL.GETTERS.getCurrentMemberDetails,
      membershipInfo: VUEX_GENERAL.GETTERS.getMembershipInfo,
    }),

    memberDetailsDropdownLinks() {
      return [
        {
          text: 'Member details',
          to: this.toMemberSelection,
        },
        {
          text: 'Payment details',
          to: this.toPaymentDetails,
        },
        {
          text: 'Order member card',
          to: this.toRequestMemberCard,
        },
      ];
    },

    toHome() {
      return {
        name: HOME,
        params: {
          policyNumber: this.policyNumber,
        },
      };
    },

    toMemberSelection() {
      return {
        name: MY_DETAILS_MEMBER_SELECTION,
        params: {
          policyNumber: this.policyNumber,
        },
      };
    },

    toPaymentDetails() {
      return {
        name: PAYMENT_SELECTION,
        params: {
          policyNumber: this.policyNumber,
        },
      };
    },

    toRequestMemberCard() {
      return {
        name: GENERATE_MEMBER_CARD_REQUEST,
        query: { step: 1 },
      };
    },

    toPolicySelection() {
      return {
        name: MY_DETAILS_POLICY_SELECTION,
      };
    },

    moreThanOneMembership() {
      if (this.memberDetailsVuex.memberships) {
        return this.memberDetailsVuex.memberships.length > 1;
      }
      return false;
    },

    logoutUrl() {
      return `${Services.COMMON.BASE_API_URL}${this.memberDetailsVuex.memberItems.logout}`;
    },

    displayMode() {
      if (this.isHelpHq === false) {
        return getDisplayMode(this.$route?.meta.displayMode);
      }
      return 'full';
    },

    datePaidToFormatted() {
      if (this.membershipInfo) {
        const datePaidTo = this.membershipInfo.datePaidTo;
        if (datePaidTo) {
          return format(new Date(datePaidTo), 'dd MMMM yyyy');
        }
      }
      return null;
    },

    isBeforeDate() {
      if (this.membershipInfo) {
        const datePaidTo = this.membershipInfo.datePaidTo;
        if (datePaidTo) {
          const dpt = new Date(datePaidTo);
          dpt.setDate(dpt.getDate() + 1);
          return isBefore(new Date(dpt), new Date());
        }
      }
      return false;
    },

    hidePhoneDetails() {
      return !this.searchBarOpened || this.currentDevice !== DeviceTypes.DESKTOP;
    },

    showMenu() {
      if (this.currentDevice !== DeviceTypes.DESKTOP) {
        return this.displayMenuTabletMobile;
      }
      return true;
    },

    memberDetailsDisplayName() {
      if (this.memberDetailsProp.firstName.length > 13) {
        return `${this.memberDetailsProp.firstName.substring(0, 9)}...`;
      }
      return this.memberDetailsProp.firstName;
    },
  },

  methods: {
    ...mapMutations([VUEX_GENERAL.MUTATIONS.updateMembershipInfo]),

    clickOffNavbar() {
      this.currentMenu('');
      this.suggestionVisible(false);
      this.searchBarOpened = false;

      if (this.currentDevice !== DeviceTypes.DESKTOP) {
        this.displayMenuTabletMobile = false;
      }
    },

    currentMenu(target = '') {
      this.currentOpenedMenu = target;
    },

    toggleMenuDropDown(target) {
      if (this.currentOpenedMenu !== target) this.currentMenu(target);
      else this.currentMenu();

      if (this.searchBarOpened) {
        this.handleSearchClose();
      }
    },

    toggleHamburgerMenu() {
      this.displayMenuTabletMobile = !this.displayMenuTabletMobile;
      this.currentMenu();

      if (this.searchBarOpened) {
        this.handleSearchClose();
      }
    },

    toggleMemberDetails(target) {
      if (this.currentOpenedMenu !== target) this.currentMenu(target);
      else this.currentMenu();

      if (this.searchBarOpened) this.searchBarOpened = false;

      if (this.currentDevice !== DeviceTypes.DESKTOP) this.displayMenuTabletMobile = false;
    },

    toggleSearchBar() {
      const nextOpened = !this.searchBarOpened;
      this.searchBarOpened = nextOpened;

      if (nextOpened) {
        this.$nextTick(() => {
          this.$refs.searchBar?.focus?.();
        });
      }
    },

    async getMembershipData() {
      const currentMemberNumber = this.$route.params.policyNumber;

      if (this.membershipInfo?.memberNumber && this.membershipInfo?.productName && this.membershipInfo?.datePaidTo && this.membershipInfo?.coverStartDate) {
        // no need to continue since all data already exists (from previous api call)
        return;
      }

      try {
        this.apiStatus.membershipInfo.loading = true;
        this.apiStatus.membershipInfo.fail = false;
        // Set dropdown query parameter to `true` whenever navigation menu is opened
        const responseMembership = await HomePageServices.getMembershipInfo(currentMemberNumber, true);
        this.updateMembershipInfo(responseMembership);
      } catch (error) {
        logger.log(error);
        this.apiStatus.membershipInfo.fail = true;
      } finally {
        this.apiStatus.membershipInfo.loading = false;
      }
    },

    checkUrlForMember(link) {
      if (link.url.includes('$memberNumber$')) {
        return true;
      }
      return false;
    },

    submitSearch() {
      if (this.isHelpHq) {
        window.location.href = `https://${this.currentHost}/portal/${this.policyNumber}/extra/search?searchText=${this.searchTerm}&pageNum=1`;
      } else {
        this.$router.push({ name: SEARCH_RESULT_FOUND, query: { searchText: this.searchTerm } }).catch(() => {});
      }

      this.searchTerm = '';
      this.currentMenu('');
    },

    handleMenuClose() {
      if (this.currentDevice === DeviceTypes.DESKTOP) {
        this.toggleMenuDropDown('');
      } else {
        if (this.displayMenuTabletMobile) {
          this.toggleHamburgerMenu();
        }
        if (this.searchBarOpened || this.currentOpenedMenu) {
          this.toggleMenuDropDown('');
        }
      }
    },

    handleSearchIconClick() {

      if (this.currentOpenedMenu || this.displayMenuTabletMobile) {
        this.handleMenuClose();
      }

      if (this.searchBarOpened) {
        this.handleSearchClose();
        return;
      }

      this.toggleSearchBar();
    },

    handleSearchSubmit() {
      if (!this.searchTerm) {
        return;
      }

      this.submitSearch();
    },

    handleSearchSuggestionClick(searchKey) {
      this.searchTerm = searchKey;
      this.submitSearch();
      this.suggestionVisible(false);
      this.searchBarOpened = false;
    },

    handleSearchClose() {
      this.toggleSearchBar();
      this.searchTerm = '';
    },

    handleScroll() {
      // debounce by setting a 300ms delay for scroll events
      // To prevent nav flickering, account for padding reduction to ScrollY val
      if (this.currentDevice === DeviceTypes.DESKTOP) {
        setTimeout(() => {
          if (window.scrollY > 80 && !this.shrinkNavbar) {
            this.shrinkNavbar = true;
          } else if (window.scrollY < 48 && this.shrinkNavbar) {
            this.shrinkNavbar = false;
          }
        }, 300);
      }
    },

    resizeHandler() {
      // This is to fetch the current device layout so that appropriate version of my recommendation is shown
      this.currentDevice = getCurrentDeviceLayout(window.innerWidth);
      if (this.currentDevice === DeviceTypes.DESKTOP) this.displayMenuTabletMobile = false;
    },

    /**
     * This function arranges items and sub-items for the dropdown menu, so that sub items always
     * appear below their parent, but fit within the same grid format of the other parent items.
     *
     * @notice this should allow the content to always be arranged in the correct order regardless
     * of the number of columns, items and sub-items.
     * @param {[Object]} dropdownContent the children of the nav menu item clicked by the user
     */
    formatDesktopDropdownMenu(dropdownContent) {
      const numColumns = 4;
      const finalContent = [];
      const items = [];
      const subItems = [];

      for (let i = 0; i < dropdownContent.length; i++) {
        items.push({ ...dropdownContent[i], style: 'item' });
        if (dropdownContent[i].children.length !== 0) {
          subItems.push({ ...dropdownContent[i].children[0], style: 'subitem', position: i + numColumns });
        }
      }

      if (subItems.length === 0) {
        return items;
      }

      let index = 0;
      while (items.length + subItems.length > 0) {
        if (subItems.length > 0 && subItems[0].position === index) {
          finalContent.push(subItems[0]);
          subItems.splice(0, 1);
        } else if (items.length === 0) {
          finalContent.push({ text: '', url: '#', style: 'padding' });
        } else {
          finalContent.push(items[0]);
          items.splice(0, 1);
        }
        index += 1;
      }

      return finalContent;
    },

    logoutMember,
  },
};
</script>

<style lang="scss" scoped>
/*
===== TABLE OF CONTENT =====
1. NAVIGATION BAR
2. DROPDOWN
3. SIDE-MENU
4. MEMBER DETAILS
5. SEARCH BAR
6. ANIMATIONS 
*/

/*==============================================================
1. NAVIGATION BAR
==============================================================*/
#navbar {
  @include desktop {
    padding: 24px 0;
    margin: 0 20px;
  }

  @include tablet-and-below {
    padding: 12px 0;
    // Anchor absolutely positioned search dropdown to the navbar width.
    position: relative;
    margin: 0 20px;
    // Prevent `width: 100%` + horizontal margins from overflowing on mobile.
    // This keeps `#search-bar-input` aligned to the same header gutter.
    width: calc(100% - 40px);
    box-sizing: border-box;
  }
}

nav {
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-left: 0;
  margin-right: 0;
  transition: all 0.2s;
  width: 100%;

  @include desktop {
    img {
      height: 4rem;
      transition: all 0.2s;
      width: 10rem;
    }
  }

  @include tablet-and-below {
    img {
      height: 2.8rem;
      width: 6rem;
    }
  }

  ol {
    align-items: center;
    display: flex;
    gap: 16px;
    margin-bottom: 0;
  }

  // Only size inline SVG icons; do not constrain IconButton root elements.
  svg.aux-icons {
    height: 16px;
    width: 16px;
    max-height: 16px;
    max-width: 16px;
  }

  .active-icon {
    @include tablet-and-below {
      color: $NEUTRAL_WHITE !important;
      background-color: $PRIMARY_GREEN_100;
    }
  }

  .active-icon-btn {
    @include tablet-and-below {
      // Visual state is handled by IconButton (focus ring) for DHDS search icon.
    }
  }

  .menu-small-screen {
    :deep(.icon-container) {
      height: 56px;
      width: 56px;
    }

    @include desktop {
      display: none;
    }

    @include mobile {
      height: 34px;
      width: 34px;
    }
  }

  :deep(.search-small-screen) {
    @include tablet-and-below {
      margin-left: auto;
    }
  }

  .member-icon {
    max-height: 14px;
    max-width: 12px;
    padding: 0.25rem;

    @include tablet-and-below {
      color: $GREY_800;

      &:focus,
      &:focus-visible {
        color: $CRIMSON !important;
      }
    }
  }

  p {
    font-weight: 500;
    margin-bottom: 0;
    white-space: nowrap;
  }

  .drop-down {
    color: #87ac37;
    transform-origin: center;
    transform: rotate(90deg);
  }

  .menu-item-container {
    @include tablet-and-below {
      width: 100%;

      &:first-child {
        margin-top: 1.5rem;
      }
    }
  }
}

.shrunken-navbar {
  padding: 16px 0 !important;

  img {
    height: 2.8rem;
    width: 6rem;
  }
}

.navbar-toplevel-menu {
  position: static;
}

.top-level-menu-item {
  border-radius: 0;
  color: $GREY_900;
  font-size: $DESKTOP_H6_SIZE;
  margin: 0;
  min-width: max-content;
  padding: $BASE;

  @include tablet-and-below {
    border-bottom: 1.5px solid $PRIMARY_MEDIUM_GREEN_100;
    margin-bottom: -2px;
    margin-left: auto;
    margin-right: auto;
    width: 85%;
    z-index: 1;


    &:hover,
    &:focus,
    &:focus-visible {
      background-color: transparent;
      border: none;
    }
  }

  @include desktop {
    &:hover {
      background-color: $PRIMARY_EGGSHELL_40;
      border-radius: $ROUND;
      margin-bottom: -2px;
      outline: none !important;
      color: $PRIMARY_MEDIUM_GREEN_100;

      @include tablet-and-below {
        border: none;
      }
    }

    &:focus,
    &:focus-visible {
      background-color: none;
      border-radius: $ROUND;
      margin-bottom: -2px;
      outline: none !important;
    }
  }

  :deep(.icon-container) {
    @include tablet-and-below {
      margin-left: auto;
    }

    svg {
      color: #87ac37;
      max-height: 16px;
      transform-origin: center;
      transform: rotate(90deg);
      transition: transform 0.2s ease-in-out;
    }
  }
}

.top-level-menu-selected {
  border-top: none;
  margin-bottom: -2px;
  background-color: $PRIMARY_EGGSHELL_40;
  color: $PRIMARY_MEDIUM_GREEN_100;


  :deep(.icon-container) {
    svg {
      transform-origin: center;
      transform: rotate(270deg);
    }
  }
}

.nav-section-wrapper {
  @include flex-row;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  position: static;
}

#search-phone-details {
  @include desktop {
  }
}

/*==============================================================
2. DROPDOWN MENU
==============================================================*/

.navbar-dropdown-menu {
  align-items: flex-start;
  background-color: $WHITE;
  max-width: $SITE_WIDTH;
  overflow: hidden;
  position: absolute;
  transform-origin: top;
  transform: scaleY(0);
  transition: all linear $TRANSITION_TIMING;

  @include desktop {
    left: 0;
    margin-left: hutter(-0.5);
    padding: 56px 0;
    overflow: unset;
    top: 100%;
    width: 100vw;
    z-index: -2;

    &::before {
      content: '';
      background-color: $WHITE;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 2px 24px 0 rgba(22, 22, 29, 0.25);
      display: block;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 0;
      width: 100vw;
      z-index: -2;
    }
  }

  @include tablet-and-below {
    box-shadow: 0px 2px 6px 0px rgba(22, 22, 29, 0.06), 0px 2px 4px 0px rgba(22, 22, 29, 0.02);
    display: none;
    flex-direction: column;
    padding: 1.25rem 0;
    position: relative;
    top: 0;
    width: 100%;
  }

  .dropdown-menu-content {
    width: inherit;

    @include desktop {
      display: grid;
      gap: 1rem;
      grid-template-columns: 20% 20% 20% 20%;
      justify-content: center;
      transform: translateX(7rem);
      transition: transform 0.2s;
    }
  }

  .dropdown-menu-content-shrunken {
    @include desktop {
      transform: translateX(3rem) !important;
    }
  }

  .dropdown-menu-item {
    @include tablet-and-below {
      margin: 0 auto;
      padding: 0.25rem 0;
      width: 80%;
    }
  }
}

.navbar-dropdown-menu-display {
  display: flex;
}

.navbar-lvl1-item {
  a {
    color: $GREY_900;
    font-size: $DESKTOP_H7_SIZE;
    font-weight: $BOLD;
    text-decoration: none;

    &:focus,
    &:focus-visible {
      color: $CRIMSON;
    }
  }
}

.navbar-lvl2-item {
  a {
    color: $GREY_900;
    font-size: $BASE_TYPE_SIZE;
    font-weight: $NORMAL;
    text-decoration: none;

    &:hover,
    &:focus,
    &:focus-visible {
      color: $CRIMSON;
    }

    @include tablet-and-below {
      padding-left: 0.75rem;
    }
  }
}

/*==============================================================
3. SIDE-MENU
==============================================================*/

.vertical-menu {
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
  position: absolute;
  right: 0;
  top: 100%;
  width: 40%;

  @media screen and (min-width: $SITE_WIDTH) and (max-width: $TABLET_MAX) {
    right: calc((#{$SITE_WIDTH} - 100vw) / 2) !important;
  }

  @include mobile {
    width: 90%;
  }

  &::before {
    content: '';
    background-color: white;
    box-shadow: 0 2px 6px 0 rgba(22, 22, 29, 0.06);
    display: block;
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: -2;
  }
}

/*==============================================================
4. MEMBER DETAILS
==============================================================*/

.member-details-container {
  position: static;

  .member-details {
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 12px;
    position: static;

    svg {
      @include desktop {
        color: $CRIMSON;
      }
    }

    .drop-down {
      color: $PRIMARY_GREEN;
    }

    &:hover,
    &:focus,
    &:focus-visible {
      & > .top-level-menu-item {
        border-radius: $ROUND;
        background-color: $PRIMARY_EGGSHELL_40;
        margin-bottom: -2px;
      }
    }

    @include desktop {
      &:focus,
      &:focus-visible {
        outline: none !important;
      }
    }
  }
}

.member-details-dropdown {
  background-color: $WHITE;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.25);
  display: grid;
  grid-template-columns: 1fr;
  max-width: 300px;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 100%;
  transition: all $TRANSITION_TIMING;
  width: max-content;
  z-index: -2;

  @media screen and (min-width: $SITE_WIDTH) and (max-width: $TABLET_MAX) {
    right: calc((#{$SITE_WIDTH} - 100vw) / 2) !important;
  }

  @include tablet-and-below {
    align-items: flex-start;
    height: 100vh;
    max-width: unset;
  }

  @include tablet {
    width: 40%;
  }

  @include mobile {
    width: 90%;
  }

  .member-details-content-container {
    padding: 1rem 1.5rem;

    @include desktop {
      max-width: 300px;
    }

    p {
      font-weight: $NORMAL;
      margin-bottom: 0.5rem;
      white-space: normal;
    }

    .title {
      font-weight: $BOLD;
    }
  }

  .member-details-link {
    border-top: 1px solid $GREY_200;
    padding: 0.5rem 0;

    a {
      color: $GREY_900;
      text-decoration: none;

      &:hover,
      &:focus,
      &:focus-visible {
        color: $CRIMSON;
      }

      &::after {
        display: none !important;
      }
    }
  }
}

/*==============================================================
5. SEARCH BAR
==============================================================*/

:deep(.search-small-screen.icon-only-button) {
  border-radius: 0;
  margin: 0;
  padding: 0;

  &:hover {
    background-color: transparent;
    @media (hover: hover) {
      color: $PRIMARY_MEDIUM_GREEN_100;
    }
  }
}

// MemberPortal nav search dropdown alignment (mobile/tablet)
// Global header styles set `.search-bar-container` to `width: 100%` with
// horizontal padding. In the portal nav, mobile menu/dropdown content is
// centered and narrower; match that so the search bar lines up.
#search-bar-input.search-bar-container {
  @include tablet-and-below {
    align-items: center;
    background-color: $WHITE;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: $BASE 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    width: 100%;
    z-index: 2;

    #site-search-bar {
      width: 100%;
    }
  }
}

/*==============================================================
6. ANIMATIONS
==============================================================*/
.navbar-dropdown-animation {
  max-height: none;
  transform: scaleY(1);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  animation-duration: 0.5s;
  animation-name: slideIn;
}

.slide-leave-active {
  animation-duration: 0.15s;
  animation-name: slideOut;
}
</style>
